import React, { FC } from "react";
import Heading from "components/Heading/Heading";

export interface SectionWhySchoonProps {
  className?: string;
}

const BENEFITS = [
  {
    icon: "💧",
    title: "Water Conservation",
    description: "Just 4.5 liters of water per car (vs 450 liters at regular washes)"
  },
  {
    icon: "🌿",
    title: "Zero Emissions",
    description: "No extra driving or emissions"
  },
  {
    icon: "🚗",
    title: "Convenient Service",
    description: "Eco-friendly service right where you're parked"
  },
  {
    icon: "♻️",
    title: "Sustainable Choice",
    description: "Less water, less waste, more clean"
  },
];

const SectionWhySchoon: FC<SectionWhySchoonProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionPrioritizingSustainability relative ${className}`}>
      <div className="bg-lime-50 dark:bg-lime-900 dark:bg-opacity-20 p-8 rounded-3xl max-w-7xl mx-auto px-4">
        <Heading
          isCenter
          desc="Because your time is valuable—and so is the planet.
At Schoon, we make car care effortless by bringing eco-friendly, high-quality cleaning straight to where your car is parked. No lines, no hassle, no wasted water.
"
        >
          Why schoon?
        </Heading>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((benefit, index) => (
            <div
              key={index}
              className="flex items-center justify-center"
            >
              <div
                className="bg-white dark:bg-neutral-800 rounded-full p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 w-64 h-64 flex flex-col items-center justify-center text-center"
              >
                <span className="text-4xl mb-3">{benefit.icon}</span>
                <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-neutral-700 dark:text-neutral-300 text-sm">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionWhySchoon;
